
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { FormVorlageDto } from "@/dtos/formVorlageDto";
import FormTemplateDataTable from "@/components/FormTemplateDataTable.vue";
import rules from "@/store/rules";

@Component({
	components: {
		FormTemplateDataTable,
	},
})
export default class FormTemplateSettings extends Vue {
	private loading: boolean = false;
	private saving: boolean = false;
	private templates: Array<FormVorlageDto> = new Array<FormVorlageDto>();
	private editDialog: boolean = false;
	private currentEditTemplate: FormVorlageDto = new FormVorlageDto();
	private isValid: boolean = false;
	private featureTypes: any = [
		{ name: "Gewinde", id: 7 },
		{ name: "Senkungen", id: 8 },
		{ name: "Gewindedurchzüge", id: 9 },
		{ name: "Zylindersenkungen", id: 13 },
	];
	private senkungsSeiteTypes: any = ["Oberseite", "Unterseite"];
	private requiredRule = rules.requiredRule;
	private requiredStringMax50Rule = rules.requiredStringMax50Rule;
	private requiredStringMax10Rule = rules.requiredStringMax10Rule;
	private requiredMax1DecimalNumberRule: any = [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => this.countDecimals(v) <= 1 || "Darf max. 1 Dezimalstelle haben.",
	];

	private mounted() {
		this.loadTemplates();
	}

	private get gewindeTemplates() {
		return this.templates.filter((t: FormVorlageDto) => t.featureType == 7);
	}
	private get senkungsTemplates() {
		return this.templates.filter((t: FormVorlageDto) => t.featureType == 8);
	}
	private get durchzugTemplates() {
		return this.templates.filter((t: FormVorlageDto) => t.featureType == 9);
	}
	private get zylinderSenkungsTemplates() {
		return this.templates.filter((t: FormVorlageDto) => t.featureType == 13);
	}

	private get formTab() {
		let tab = localStorage.getItem("formTab");
		if (tab != null) {
			return parseInt(tab);
		}
		return 1;
	}

	private set formTab(newTab: number) {
		localStorage.setItem("formTab", newTab.toString());
	}

	private get templatesLoaded() {
		return this.templates.length > 0;
	}

	private async loadTemplates() {
		try {
			this.loading = true;
			const response = await httpClient().get("Material/GetFormVorlagen");
			this.templates = response.data;
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Laden der Formvorlagen fehlgeschlagen.");
			console.log(err);
		} finally {
			this.loading = false;
		}
	}

	private async saveTemplate() {
		if (!this.isValid || this.saving) {
			console.log("Form is not valid.");
			return;
		}
		try {
			this.saving = true;
			await httpClient().post("Material/SaveFormVorlage", this.currentEditTemplate);
			this.replaceNewTemplate();
			this.editDialog = false;
			this.$store.commit("setSnackbarText", "Vorlage erfolgreich gespeichert.");
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Vorlage konnte nicht gespeichert werden.");
			console.log(err);
		} finally {
			this.saving = false;
		}
	}

	private async addTemplate(type: number) {
		try {
			this.saving = true;
			await httpClient().post("Material/SaveFormVorlage", {
				formId: 0,
				name: "Neue Vorlage",
				description: "neu",
				text: "neu",
				parameters: [],
				featureType: type,
				isActive: true,
			});
			this.$store.commit("setSnackbarText", "Vorlage erfolgreich gespeichert.");
			location.reload();
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Vorlage konnte nicht gespeichert werden.");
			console.log(err);
		} finally {
			this.saving = false;
		}
	}

	private editTemplate(id: number) {
		this.currentEditTemplate = JSON.parse(
			JSON.stringify(this.templates.filter((t: FormVorlageDto) => t.formId === id)[0])
		);
		this.editDialog = true;
	}

	private async deleteTemplate(id: number) {
		try {
			this.saving = true;
			await httpClient().post(`Material/DeleteFormVorlage?formId=${id}`);
			this.deleteLocalTemplate(id);
			this.$store.commit("setSnackbarText", "Vorlage gelöscht.");
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Vorlage konnte nicht gelöscht werden.");
			console.log(err);
		} finally {
			this.saving = false;
		}
	}

	private replaceNewTemplate() {
		let index = this.templates.indexOf(
			this.templates.filter(
				(t: FormVorlageDto) => t.formId === this.currentEditTemplate.formId
			)[0]
		);
		this.templates.splice(index, 1, JSON.parse(JSON.stringify(this.currentEditTemplate)));
	}

	private deleteLocalTemplate(formId: number) {
		let index = this.templates.indexOf(
			this.templates.filter((t: FormVorlageDto) => t.formId === formId)[0]
		);
		this.templates.splice(index, 1);
	}

	private countDecimals(value: any) {
		let n = parseFloat(value);
		if (n === null || n === undefined || isNaN(n)) {
			return 0;
		}
		if (Math.floor(n) === n) {
			return 0;
		}
		let decimals = n.toString().split(".");
		if (decimals.length > 1) {
			return decimals[1].length;
		} else {
			return 0;
		}
	}
}
